export const PASSWORD_LENGTH = 8;
export const REGEX_EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/i;
export const REGEX_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>[\]\\/`~_\-+=;'`])[A-Za-z\d!@#$%^&*(),.?":{}|<>[\]\\/`~_\-+=;'`]{8,}$/;
export const REGEX_PHONE = /^\d{11}$/;